module.exports = __webpack_public_path__ + "static/media/forms-icon.42e38ff9.svg";